import React from 'react';
import styled from 'styled-components';

import { StarCheck } from 'src/assets/star-check';
import { useCardContext } from './card-context';

/** "Staff Pick" text tag with star icon. Renders nothing when the product is not a staff pick. */
export function CardStaffPickTag(): JSX.Element | null {
  const { isStaffPick } = useCardContext();

  if (!isStaffPick) {
    return null;
  }

  return (
    <Tag>
      <StarCheck />
      Staff Pick
    </Tag>
  );
}

const Tag = styled.div`
  align-items: center;
  color: var(--dcm-color-staff-pick-tag, ${({ theme }) => theme.customized.colors.staffPickTag});
  display: flex;
  font-size: 12px;
  font-weight: 500;
  gap: 4px;
  line-height: 1;
  white-space: nowrap;
`;
